import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
} from "@mui/material";
import {deleteAccount} from './action.ts';
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
interface SettingsScreenProps {
    onClose: () => void;
    userRole:string;
    appVersion:any;
  }
  const SettingsScreen = ({ onClose,userRole,appVersion }: SettingsScreenProps) => {
  const navigate = useNavigate();
  const [showLogoutAlert, setShowLogoutAlert] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [urlParams, setUrlParams] = useState({
      userName:'',
      userPhone:'',
    });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    setUrlParams({
      userName: queryParams.get('user_name') || '',
      userPhone: queryParams.get('user_phone') || ''
    });
  }, []);
  const settingsOptions = [
    { title: "My Profile", key: "profile" },
    { title: "Change PIN", key: "change-pin" },
    { title: "Change Language", key: "change-language" },
    { title: "Terms & Conditions", key: "terms" },
    { title: "Privacy Policy", key: "privacy" },
    { title: "Delete Account", key: "delete-account" },
  ];
  const handleSettingClick = (key) => {
    switch (key) {
      case "profile":
        console.log("profile")
        break;
      case "change-pin":
        console.log("profile")
        break;
      case "change-language":
        console.log("profile")
        break;
      case "terms":
        console.log("profile")
        break;
      case "privacy":
        console.log("profile")
        break;
      case "delete-account":
        setShowDeleteConfirm(true);
        break;
      default:
        break;
    }
  };
  const handleDeleteAccount = async () => {
deleteAccount(  (response)=>{if(response.status === 200) {
  localStorage.removeItem("token");
  if ((window as any).ReactNativeWebView){
    (window as any).ReactNativeWebView.postMessage('account-deleted');
  } 
}}  , (errorMessage) => {
  toast.error(errorMessage.message)
}  
 )}
  const handleLogout = () => {
    setIsLoading(true);
    setTimeout(() => {
      localStorage.removeItem("token");
      if ((window as any).ReactNativeWebView){
        (window as any).ReactNativeWebView.postMessage('logout');
      } 
    }, 1000);
  };
  const handleBack = () => {
    onClose();
  }
  
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        backgroundColor: "#f5f5f5",
        paddingTop:'30px'
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: 2,
          backgroundColor: "white",
          boxShadow: 1,
        }}
      >
        <Button onClick={handleBack} sx={{ minWidth: 'auto', mr: 1 }}>
    <ArrowBackIcon /> 
  </Button>
  <SettingsIcon sx={{ fontSize: 30, color: "primary.main", mr: 1 }} />
  <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
    Settings
  </Typography>
      </Box>
      <Paper sx={{ flex: 1, margin: 2, overflow: "auto" }}>
        <List>
          {settingsOptions.map((item, index) => (
            <ListItem
              button
              key={item.key}
              onClick={() => handleSettingClick(item.key)}
              divider={index < settingsOptions.length - 1}
            >
              <ListItemText primary={item.title} />
            </ListItem>
          ))}
        </List>
      </Paper>

      <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", p: 1 }}>
       {appVersion}
      </Typography>
      <Box sx={{ p: 2 }}>
        <Button
          variant="contained"
          color="error"
          fullWidth
          size="large"
          startIcon={<LogoutIcon />}
          onClick={() => setShowLogoutAlert(true)}
          disabled={isLoading}
        >
          {isLoading ? "Logging out..." : "Logout"}
        </Button>
      </Box>
      <Dialog
        open={showLogoutAlert}
        onClose={() => setShowLogoutAlert(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to logout?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowLogoutAlert(false)}>Cancel</Button>
          <Button
            onClick={handleLogout}
            color="error"
            variant="contained"
            autoFocus
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete your account? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDeleteConfirm(false)}>Cancel</Button>
          <Button
            onClick={handleDeleteAccount}
            color="error"
            variant="contained"
            autoFocus
          >
      Delete
    </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
};

export default SettingsScreen;